import React from 'react';
import { Navigate } from 'react-router-dom';
import { authUtils } from '../services/api';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const isAuthenticated = authUtils.isAuthenticated();
  const currentUser = authUtils.getCurrentUser();

  // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si la route nécessite des droits admin et que l'utilisateur n'est pas admin
  if (requireAdmin && currentUser?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  // L'utilisateur est authentifié et a les bonnes permissions
  return children;
};

export default ProtectedRoute;
